import { isLegalAge } from './functions/is-legal-age.function';
import { isValidPhone } from './functions/is-valid-phone.function';

export * from './functions/is-legal-age.function';
export * from './functions/is-valid-phone.function';

export * from './schemas/legal-age.schema';
export * from './schemas/pay.schema';
export * from './schemas/phone.schema';
export * from './schemas/set-operation-status.schema';
export * from './schemas/set-status-with-dates-validation.schema';
export * from './schemas/set-status.schema';

export const phoneValidators = { isValidPhone };
export const dateValidators = { isLegalAge };
